import { render, staticRenderFns } from "./reject-icon.vue?vue&type=template&id=2f228be1"
import script from "./reject-icon.vue?vue&type=script&lang=js"
export * from "./reject-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports